// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.clientMenu {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
}

.clientMenu a {
  color: black;
  font-size: small;
}

ion-card {
  width: 95%;
  padding: 15px;
  background-color: white;
  border-radius: 15px;
  box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
  min-height: 261px;
  margin: auto;
}

ion-searchbar {
  --box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
  --border-radius: 15px;
  --background: #f7f7f7;
}

.clients {
  width: 100%;
  display: flex;
  flex-wrap: nowrap;
  overflow-x: scroll;
  flex-direction: row;
  text-align: center;
}

.clients::-webkit-scrollbar {
  width: 0;
}

a {
  text-decoration: none;
}

.clientBox {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.5rem;
  flex: 0 0 auto;
  height: 3rem;
  width: 3rem;
  border-radius: 80px;
  cursor: pointer;
  color: white;
}

.clientBox p {
  overflow: hidden;
  white-space: nowrap;
}`, "",{"version":3,"sources":["webpack://./src/app/components/Coach/widgets/my-client/my-client.component.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,WAAA;AACJ;;AAEE;EACE,YAAA;EACA,gBAAA;AACJ;;AAEE;EACE,UAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iDAAA;EACA,iBAAA;EACA,YAAA;AACJ;;AAEE;EACE,6CAAA;EACA,qBAAA;EACA,qBAAA;AACJ;;AAEE;EACE,WAAA;EACA,aAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;AACJ;;AAEE;EACE,QAAA;AACJ;;AAEE;EACE,qBAAA;AACJ;;AACE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,cAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;EACA,eAAA;EACA,YAAA;AAEJ;;AACE;EACE,gBAAA;EACA,mBAAA;AAEJ","sourcesContent":[".clientMenu {\r\n    display: flex;\r\n    flex-direction: row;\r\n    justify-content: space-between;\r\n    width: 100%;\r\n  }\r\n  \r\n  .clientMenu a {\r\n    color: black;\r\n    font-size: small;\r\n  }\r\n  \r\n  ion-card{\r\n    width: 95%; \r\n    padding: 15px;\r\n    background-color: white;\r\n    border-radius: 15px;\r\n    box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;\r\n    min-height: 261px;\r\n    margin: auto;\r\n  }\r\n\r\n  ion-searchbar{\r\n    --box-shadow:  rgba(0, 0, 0, 0.24) 0px 3px 8px;\r\n    --border-radius : 15px;\r\n    --background: #f7f7f7;\r\n  }\r\n  \r\n  .clients {\r\n    width: 100%;\r\n    display: flex;\r\n    flex-wrap: nowrap;\r\n    overflow-x: scroll;\r\n    flex-direction: row;\r\n    text-align: center;\r\n  }\r\n  \r\n  .clients::-webkit-scrollbar{\r\n    width: 0;\r\n  }\r\n  \r\n  a{\r\n    text-decoration: none;\r\n  }\r\n  .clientBox {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    padding: 0.5rem;\r\n    flex: 0 0 auto;\r\n    height: 3rem;\r\n    width: 3rem;\r\n    border-radius: 80px;\r\n    cursor: pointer;\r\n    color: white;\r\n  }\r\n  \r\n  .clientBox p{\r\n    overflow: hidden;\r\n    white-space: nowrap;\r\n  }\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
